var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTreeViewArrow = function SvgTreeViewArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.013 3.763 6.707 7.945 2.4 3.763a1.11 1.11 0 0 0-1.546 0 1.04 1.04 0 0 0-.323.75c0 .282.117.553.323.751l5.069 4.922c.43.419 1.126.419 1.556 0l5.08-4.922c.43-.418.43-1.083 0-1.501a1.109 1.109 0 0 0-1.546 0Z",
    fill: "#7678DF"
  })));
};
export default SvgTreeViewArrow;